import type { ILoadingCellRendererParams } from 'ag-grid-community';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

export const LoadingCell: FC<ILoadingCellRendererParams> = ({ api }) => {
  const columns = api.getAllDisplayedColumns();
  return (
    <>
      {columns.map(c => {
        const w = c.getActualWidth() - 32;
        return (
          <div className="mx-3" key={c.getId()}>
            <Skeleton width={w} />
          </div>
        );
      })}
    </>
  );
};
